export const STORAGE_KEYS = {
  token: "TOKEN",
  refreshToken: "REFRESH_TOKEN",
  credentials: "CREDENTIALS",
  userData: "USER_DATA",
  articleData: "ARTICLE_DATA",
};
